import React from 'react';
import './token-redemption-sign-details.scss';
import Step from 'modules/step';
import { DangerIcon } from 'assets/icons';
import { TokenRedemptionType } from 'constants/redemption';
import TokenRedemptionParams from '../TokenRedemptionParams';

interface ITokenRedemptionSignDetails {
  redemptionType: TokenRedemptionType;
  asset: any;
}

export default function TokenRedemptionSignDetails({
  redemptionType,
  asset,
}: ITokenRedemptionSignDetails) {
  return (
    <div className="token-redemption-sign-details">
      <div className="token-redemption-sign-details__left">
        <div className="mb_32">
          <Step
            steps={[
              { title: 'Инициализация погашения', active: true },
              { title: 'Оплата' },
              { title: 'Подтверждение погашения' },
            ]}
          />
        </div>
        <p className="p p_font-size_24 p_font-weight_light mb_32">
          Погашение {asset.actualCount} токенов
          <br />
          {asset.issuingInfo.tokenName}
        </p>
        <div className="token-redemption-sign-details__important-info">
          <div className="token-redemption-sign-details__important-info-header">
            <DangerIcon />
            <p className="p p_bold p_color_orange">
              Важная информация о погашении
            </p>
          </div>
          <div className="token-redemption-sign-details__important-info-body">
            <p className="p">Для инициализации погашения необходимо подписать транзакцию Вашим приватным Ключом</p>
          </div>
        </div>
      </div>
      <div className="token-redemption-sign-details__right">
        <p className="p p_bold mb_24">Параметры погашения</p>
        <TokenRedemptionParams redemptionType={redemptionType} asset={asset} />
      </div>
    </div>
  );
}
